import { render, staticRenderFns } from "./AddressValidationScreen.vue?vue&type=template&id=ce466054&scoped=true"
import script from "./AddressValidationScreen.vue?vue&type=script&lang=js"
export * from "./AddressValidationScreen.vue?vue&type=script&lang=js"
import style0 from "./AddressValidationScreen.vue?vue&type=style&index=0&id=ce466054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce466054",
  null
  
)

export default component.exports